<script>
export default {
  name: "MobileMenu",

  props: {
    navigation: {
      type: Array,
      required: true,
    },
  },

  emits: ["close"],

  watch: {
    $route(newValue) {
      console.log(newValue);
      this.$emit("close");
    },
  },
};
</script>

<template>
  <aside class="mobile-menu">
    <div
      class="mobile-menu__wrapper"
      v-motion
      :initial="{
        opacity: 0,
        y: 300,
      }"
      :enter="{
        opacity: 1,
        y: 0,
        transition: {
          duration: 600,
          type: 'keyframes',
          ease: 'ease',
        },
      }"
    >
      <button type="button" @click="$emit('close')">
        <img src="@/assets/icons/close.svg" alt="close" />
      </button>

      <h3>Меню</h3>

      <div class="mobile-menu__list">
        <router-link
          :to="{ name: item.path }"
          v-for="(item, index) in navigation"
          :key="index"
        >
          {{ item.name }}
        </router-link>
      </div>
    </div>
  </aside>
</template>

<style scoped lang="scss">
.mobile-menu {
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(5px);
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 5;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;

  &__wrapper {
    padding: ($base-space * 8) ($base-space * 4);
    border-radius: 20px 20px 0px 0px;
    background-color: $grey-4;
    width: 100%;
    position: relative;

    > button {
      position: absolute;
      width: 28px;
      height: 28px;
      top: 16px;
      right: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    > h3 {
      @include h2();
      color: $white;
    }
  }

  &__list {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: $base-space * 4;
    margin: ($base-space * 8) 0 0;

    > a {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      padding: ($base-space * 4) ($base-space * 8);
      @include body-1();
      color: $black;
      border-radius: 6px;
      background-color: $grey-1;
      transition: all 0.3s ease-in;

      &:hover {
        background-color: $grey-2;
      }

      &.router-link-active {
        background-color: $orange-1;
        color: $white;

        &:hover {
          background-color: $orange-1;
        }
      }
    }
  }
}
</style>
